import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext, businessId: string) {
  return this.sendEvent('onboarding.businessUpdated', { businessId })
}
